import ManageAdmission from '@/views/parametres/tarif-admissions/manage-admission'
import ExcelModal from '@/views/parametres/import-excel-modal'
import $ from 'jquery'

export default {
    name: 'tarif-admissions',
    components: {
        ManageAdmission, ExcelModal
    },
    props: [],
    data() {
        return {
			can_show_assur: false,

            chambre_empty: false,
            chambre_loading: true,

            observation_empty: false,
            observation_loading: true,

            autre_adm_empty: false,
            autre_adm_loading: true,

            can_see_caracteristique: false,
            type_tarif_admission: '',

            save_loading: false,
            btn_disable: false,

            admission_field: [
				{ key: 'libelle', label: 'Libellé' }, 'prix', { key: 'avec_chambre', label: 'Avec chambre' },
                { key: 'avec_observation', label: 'Avec observation' }, { key: 'facturation_acte', label: 'Facturation acte' },
                { key: 'prix_acte', label: 'Prix acte journalier' }, { key: 'actions', label: 'Action.s' }
			],
			filter: "",

            autre_fields: [
				'libelle', 'prix', { key: 'caracteristique', label: 'Caractéristique' }, 'actions'
			],
			autre_filter: "",

			perPage: 20,
			currentPage: 1,

            // >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
            del_disable: false,

            is_printing_autre: false,
            is_printing_hospi: false,
            filename: '',
            is_hospi: true,

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            admission_to_fill: {
                user_id: 0,
                admission_id: 0, 
                libelle: '',
                is_billable: 'Oui', 
                prix: '',
                is_with_room: '',
                is_with_observation: '',
                facturation_acte: '',
                prix_journalier: ''
            },
            adm_modal_title: 'Nouvelle admission',

            type_admission_to_delete: {},

            admission_is_empty: false,
            admission_is_loading: true,

            print_title: '',
            pdf_orientation: '',
            pdf_content_width: '',

            admission_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Avec Chambre': 'with_room',
                'Avec Observation': 'with_observation',
                'Modèle de facturation': 'model_facturation',
                'Prix Acte Journalier': 'prix_acte_journalier'
            },
            admission_data: [],

            chambre_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Caractéristique': 'caracteristique'
            },

            observation_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Caractéristique': 'caracteristique'
            },

            chambre_data: [],
            observation_data: [],

            admission_filename: 'Liste_Admissions.xls',
            chambre_filename: 'Liste_Chambres.xls',
            observation_filename: 'Liste_Chambres.xls'
        }
    },

    computed: {
        tarif_hospitalisations() {
            return this.$store.getters["tarif_hospitalisations"];
        },

        tarif_autre_admissions() {
            return this.$store.getters["tarif_autre_admissions"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        liste_adimissions() {
            return this.$store.getters["liste_adimissions"];
        },

        adm_row() {
            return this.liste_adimissions.length;
        },

        liste_chambres() {
            return this.$store.getters["liste_chambres"];
        },

        liste_observations() {
            return this.$store.getters["liste_observations"];
        },
    },

    mounted() {
        // Liste des Admissions
        this.getListeAdmission()

        // Liste autre type d'admission
        this.getListeChambre()

        this.getListeObservation()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_admission_'+tmpstamp
    },

    methods: {
        importTypeAdmission(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            if (type_admission == 'admission') {
                this.emit_action = 'emitAdmission'
            } else if (type_admission == 'chambre') {
                this.emit_action = 'emitChambre'
            } else if (type_admission == 'observation') {
                this.emit_action = 'emitObservation'
            }
            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        addAdmission() {
            this.adm_modal_title = 'Nouvelle admission'
            this.type_admission = 'admission'
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: 0, 
                libelle: '',
                is_billable: 1, 
                prix: '',
                is_with_room: 0,
                is_with_observation: 0,
                facturation_acte: '',
                prix_journalier: '',
                type_admission: 'admission'
            }
        },

        addAutreTypeAdmission(type_admission) {
            this.adm_modal_title = 'Nouvelle '+type_admission
            this.type_admission = type_admission
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: 0, 
                libelle: '',
                prix: '',
                caracteristique: '',
                type_admission: type_admission
            }
        },

        editAdmission(data, type_admission) {
            this.adm_modal_title = 'Modifier une '+type_admission
            this.type_admission = type_admission
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: data.admission_id, 
                libelle: data.libelle,
                is_billable: data.is_billable, 
                prix: data.prix,
                is_with_room: data.is_with_room,
                is_with_observation: data.is_with_observation,
                facturation_acte: data.facturation_acte,
                prix_journalier: data.prix_acte_journalier,
                caracteristique: data.caracteristique,
                type_admission: type_admission
            }
        },

        setTypeAdmissionToRemove(data, type_admission) {
            let label = ''
            if (type_admission == 'admission') {
                label = 'l\'admission'
            } else if (type_admission == 'chambre') {
                label = 'la chambre'
            } else if (type_admission == 'observation') {
                label = 'l\'observation'
            }
            this.type_admission_to_delete = {
                user_id: this.userCredentials.id,
                admission_id: data.admission_id, 
                libelle: data.libelle,
                type_admission: label,
                type_del: type_admission
            }
        },

        /**
         * 
         * @param {*} status 0 => Non | 1 => Oui
         */
        setStatus(status) {
            let label = ''
            switch (status) {
                case 0:
                    label = 'Non'
                    break
                case 1:
                    label = 'Oui'
                    break
            }
            return label
        },

        getListeAdmission() {
            this.admission_is_loading = true
            this.$store.dispatch("getListeTypeAdmission", 'admission').then(() => {
                if (this.liste_adimissions.length > 0) {
                    this.admission_is_empty = false

                    this.liste_adimissions.forEach(admission => {
                        this.admission_data.push({
                            'libelle' : admission.libelle,
                            'prix' : (admission.prix > 0)?admission.prix:'',
                            'with_room': (admission.is_with_room == 1)?'OUI':'NON',
                            'with_observation': (admission.is_with_observation == 1)?'OUI':'NON',
                            'model_facturation': (admission.facturation_acte != null)?admission.facturation_acte:'',
                            'prix_acte_journalier': (admission.prix_acte_journalier > 0)?admission.prix_acte_journalier:''
                        })
                    });
                } else {
                    this.admission_is_empty = true
                }
                this.admission_is_loading = false
            })
        },

        getListeChambre() {
            this.chambre_loading = true
            this.$store.dispatch("getListeTypeAdmission", 'chambre').then(() => {
                if (this.liste_chambres.length > 0) {
                    this.chambre_empty = false

                    this.liste_chambres.forEach(chambre => {
                        this.chambre_data.push({
                            'libelle' : chambre.libelle,
                            'prix' : (chambre.prix > 0)?chambre.prix:'',
                            'caracteristique': chambre.caracteristique
                        })
                    });
                } else {
                    this.chambre_empty = true
                }
                this.chambre_loading = false
            })
        },

        getListeObservation() {
            this.observation_loading = true
            this.$store.dispatch("getListeTypeAdmission", 'observation').then(() => {
                if (this.liste_observations.length > 0) {
                    this.observation_empty = false

                    this.liste_observations.forEach(observation => {
                        this.observation_data.push({
                            'libelle' : observation.libelle,
                            'prix' : (observation.prix > 0)?observation.prix:'',
                            'caracteristique': observation.caracteristique
                        })
                    });
                } else {
                    this.observation_empty = true
                }
                this.observation_loading = false
            })
        },
        

        setTypeAdmissionToPrint(type_admission) {
            this.print_title = type_admission
        },

        handleBeforeGenerateChambre() {
            let d = new Date()
            this.chambre_filename = 'Liste_Chambres_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.admission_filename = 'Liste_Admissions_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        handleBeforeGenerateObservation() {
            let d = new Date()
            this.observation_filename = 'Liste_Observations_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },
    }
}


